import { useState } from "react"
import { Trans } from "react-i18next"
import { useLocation } from "react-router"

//Logo
import logo from "../../assets/images/menu/Logo.svg"

const Menu = () => {
  const [activo, setActivo] = useState(false)

  const toggleMenu = () => {
    setActivo(!activo)
  }

  const { pathname } = useLocation()

  return (
    <nav className="menu">
      <div className="menu__links-lenguajes d-none d-md-flex align-items-center">
        <a href="/" className="active">
          Es
        </a>
        <div className="separador"></div>
        <a href="http://en.margot-ec.com.ar/">En</a>
      </div>

      <a className="menu__logo" href="/" title="Logo">
        <img src={logo} alt="Margot" />
      </a>

      <button
        className={
          activo ? "menu__toggler menu__toggler--activo" : "menu__toggler"
        }
        type="button"
        onClick={toggleMenu}
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <a
        href="https://wa.me/5493425662175"
        target="_blank"
        rel="noopener noreferrer"
        className="menu__button-reserva d-none d-md-flex button button__primary"
      >
        <Trans i18nKey="components.ctaLabel" />
      </a>

      <div
        className={
          activo ? "menu__content menu__content--activo" : "menu__content"
        }
      >
        <div className="footer">
          <div className="container">
            <div className="row justify-content-between text-center text-sm-left">
              <div className="menu__reserva d-sm-flex d-md-flex flex-wrap col-12 col-sm-6">
                <div>
                  <a
                    className="button button__primary"
                    href="https://wa.me/5493425662175"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Trans i18nKey="components.ctaLabel" />
                  </a>
                </div>

                <div className="menu__links-lenguajes d-none d-sm-flex align-items-center align-self-end">
                  <a href="/">Es</a>
                  <div className="separador"></div>
                  <a href="http://en.margot-ec.com.ar/">En</a>
                </div>
              </div>
              <div className="direccion col-12 col-sm-6 col-md-5">
                <div>
                  <p>
                    Talcahuano 6960 (S3004JEL) Santa Fe, Provincia de Santa Fe,
                    Argentina
                  </p>
                  <p>+54 9 3425 66-2175</p>
                  <p>contacto@margot.com</p>
                </div>
                <div>
                  <ul className="media button__secondary justify-content-center justify-content-sm-start">
                    <li>
                      <a href="https://www.instagram.com/margot_e.c/?hl=en">
                        INSTAGRAM
                      </a>
                    </li>
                    <li>
                      <a href="https://www.facebook.com/margotrestostafe/">
                        FACEBOOK
                      </a>
                    </li>
                  </ul>

                  <div className="menu__links-lenguajes d-flex d-sm-none align-items-center justify-content-center">
                    <a href="/" className="active">
                      Es
                    </a>
                    <div className="separador"></div>
                    <a href="http://en.margot-ec.com.ar/">En</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  )
}

export default Menu
